import { isPayloadSource } from "src/utils/hubSource";

/**
 * Navbar data source: `static` (navbarLinks.js) or `payload` (pg-payload-cms).
 * Controlled by `navbar` in `REACT_APP_PAYLOAD_SOURCES`.
 * @returns {'static' | 'payload'}
 */
export function getNavbarSource() {
  return isPayloadSource("navbar") ? "payload" : "static";
}

export function isPayloadNavbarSource() {
  return isPayloadSource("navbar");
}
